import React, { useEffect, useState } from 'react';
import Button from '../Components/Button';
import './Layout.css';
import { Card } from '@mui/material';
import Table from '../Components/Tables';

import { useNavigate } from 'react-router-dom';
const Layout =(props)=>{

    const navigate = useNavigate();
    const [department,setDeparment]=useState('');
    const closeWindow=()=> {
             // Open the new window
            // with the URL replacing the
            // current page using the
            // _self value
            window.close();

            return false;

       // Closes the new window
    }


    return(
    <>
     <button onClick={closeWindow} style={{marginTop:"2%"}}  className="btn btn-secondary mb-3">
     <i className="fa fa-arrow-left"  aria-hidden="true"></i>
        </button>
     <Card  style={{width:"100%",border:"2px solid" ,borderColor:'#3278bd', backgroundColor:"lightgrey"}}>
     <div >
      <h2 className="h2">IVY Ticketing Solution</h2>
      <h3 className="h3">Welcome, IVY ticket User this solution was made to help all IVY community members to have the smoothest experiences in IVY. If there is any problem you are facing please don't hesitate to add a ticket and we will review your complainent and get back to you ASAP.</h3>
     </div>
     {((props.user?.role_id==="1")||(props.user?.role_id==="2"))?
     <div  style={{textAlign:"center",display:"flex",justifyContent:"space-evenly"}} >
     <button  className='bttn' onClick={()=>{navigate("/ticket/other")}}>Add Ticket For User</button>
     <button  className='bttn' onClick={()=>{navigate("/ticket")}}>Add New Ticket</button>
     </div>
     :<div  style={{textAlign:"center"}} >
     <button  className='bttn' onClick={()=>{navigate("/ticket")}}>Add New Ticket</button>
     </div>}
     <div  style={{margin:"2%"}} >
        <Table departmentid={department}/>
     </div>
     </Card>
    </>

    )
}
export default Layout;